<template>
<div>
<div v-if="type=='A'" class="modal" id="movementModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered " role="document">
    <div class="modal-content border-primary">
      <div style="background-color:rgb(175, 154, 32);" class="modal-header border-primary">
        <h5  class="modal-title" id="exampleModalLongTitle"> 
          <i style="color:black" class="fas fa-dolly mr-2" aria-hidden="true"></i>
          <strong>TRASFERIMENTO PRODOTTO </strong></h5>
      </div>
      <div class="modal-body" >
        
        <div class="form-group">
          <label for="exampleFormControlSelect1"><strong>DESTINAZIONE</strong></label>
          <select class="form-control" id="storeId" v-model="to_storeId">
            <option v-for="(item,index) in stores" :key="index" v-bind:value="item.storeId">
              {{item.store}}
            </option>
          </select>
          <small style="color:red"  class="form-text "><strong>{{msg}}</strong> </small> 
                    
        </div>
      </div>
      <div class="form-check text-center" >
            <input class="form-check-input" type="checkbox" id="defaultCheck1" v-model="removeCartItems">
              <label class="form-check-label" for="defaultCheck1">
                RIMUOVI PRODOTTI A TRASFERIMENTO EFFETTUATO
              </label>
          </div>                  
      <div class="modal-footer">
        <button @click="closeModal()" type="button" class="btn btn-outline-secondary" >CHIUDI</button>
        <button @click="submit()" type="button"  class="btn btn-primary">
          <i  class="fas fa-check-circle mr-3" aria-hidden="true"></i>
          ESEGUI</button>
      </div>
    </div>
  </div>
</div>
<div v-else>
  <waitingBoxModal v-if="waitModal.show" @close="closeWaitingModal()"  v-bind:props="waitModal" ></waitingBoxModal>
</div>

<dialogBoxModal v-if="dialogBoxModal.show" @close="closeDialogBox()" v-bind:props="dialogBoxModal"></dialogBoxModal>

</div>
</template>
<script>
import { mapGetters }        from 'vuex'
import api                   from '@/api'
import waitingBoxModal       from "@/components/common/WaitingModal.vue"
import dialogBoxModal        from '@/components/frontOffice/cart/dialogBoxModal.vue'
export default {
  
  props      : ['cart','resetCart'],
  components : {waitingBoxModal,dialogBoxModal},
 
  data () 
  {
    return {
      msg                 : '',
      stores              : [],
      to_storeId          : 0,
      type                : 'A',
      waitModal           : 
      {
        sentinel          : 0,
        show              : false,
        msg1              : 'ELABORAZIONE IN CORSO ...',
        msg2              : 'CONTROLLARE TRASFERIMENTI.' 
      },
      dialogBoxModal      :
      {
        show              : false,
        title             : 'TRASFERIMENTO ALTRA SEDE.',
        msg               : 'TRASFERIMENTO EFFETTUATO.',
        method            : '',
        doSomeThing       : false

      },
      removeCartItems     : true  
    }
  },
    computed: 
  {
    ...mapGetters(['storeId','company']) , 
  },
  mounted: function()
  {
    this.storeList()
  },
  created: function()
  {
    this.$nextTick(()  => {                  
      $('#movementModal').modal('show')    
    })  
  },
  methods :
  {
    closeWaitingModal()
    {
      this.waitModal.show = false
      this.waitModal.sentinel = 0
      
    },
    closeDialogBox()
    {
      this.$emit('close')     
          
    },
    async submit()
    {
      if(this.to_storeId == 0)
      {
        this.msg = 'Selezionare una destinazione.'
        return
      }
            
      $('#movementModal').modal('hide') 
      
      this.$nextTick(()  => {    
        this.type = 'B'          
        this.waitModal.show = true
        
      })  
      const data   = {}      
      data.header  = {}
      data.body    = []
      
      data.header.companyId     = this.company.Id
      data.header.senderId      = this.storeId
      data.header.storeId       = this.to_storeId    

      this.cart.forEach(item=>{
        data.body.push({'productId':item.productId,'barcode':item.barcode,'cost_price':item.cost_price})      
      })
      
      const sp     = {'sp' : 'spCreateMovementToStoreNew'}
      const json   = Object.assign(data, sp)
      await api.post(json).then(res => {
        if(res.status==200)
          {
            
            this.waitModal.sentinel  = 1

            this.$nextTick(()  => {    
                this.dialogBoxModal.show        = true
                this.dialogBoxModal.title       = 'TRASFERIMENTO ALTRA SEDE'
                this.dialogBoxModal.title       = 'TRASFERIMENTO EFFETTUATO.'
                this.dialogBoxModal.method      = this.resetCart
                this.dialogBoxModal.doSomeThing = this.removeCartItems
                   
              })  
            

            const store         = res.data.recordsets[0][0].store
            const d             = new Date()
            const date          = d.toLocaleString()       
            const senderId      = this.storeId            
            const data          = date            
            const descrizione1  = store                        
            api.postMsg({"date" : data,
            
                         "description1" : descrizione1, 
                         "description2" : '',  
                         "shippedFrom"  : senderId,
                         'shippedTo'    : this.to_storeId,
                         'rowId'        : Math.random() * this.storeId,
                         'total_qty'    : res.data.recordsets[0][0].total_qty
                        })  
            
            
          }
          else if(res.status==500)
          {
            this.dialogBoxModal.title = 'TRASFERIMENTO NON EFFETTUATO'
            this.waitModal.sentinel   = 1
            this.dialogBoxModal.msg   = res.data
            this.dialogBoxModal.show  = true
            this.dialogBoxModal.method  = ''
            this.dialogBoxModal.doSomeThing = false
            
                    
          } 
          else
          {
            this.dialogBoxModal.title       = 'TRASFERIMENTO NON EFFETTUATO'
            this.dialogBoxModal.msg         = res            
            this.dialogBoxModal.method      = ''
            this.waitModal.sentinel         = 1        
            this.dialogBoxModal.doSomeThing = false   
            this.dialogBoxModal.show        = true
            
          } 
      }).catch(err => 
      {     
            console.log(err)
            this.waitModal.sentinel         = 1
            this.dialogBoxModal.title       = 'TRASFERIMENTO NON EFFETTUATO'
            this.dialogBoxModal.msg         = err
            this.dialogBoxModal.method      = ''
            this.dialogBoxModal.show        = true
            this.dialogBoxModal.doSomeThing = false
            
      }).finally(() => {
        //this.spinner = false
      });

    },
    closeModal()
    {
      $('#movementModal').modal('hide')
      this.$nextTick(()  => {              
        this.$emit('close')        
      })    
    }, 
    storeList()
    {
        this.stores = this.company.stores.filter(item => item.storeId != this.storeId)      
    },
 
  }
}
</script>    
<style scoped>


.modal-footer {  
  justify-content: space-between;  
}
.form-check-label {
    color       : rgb(2, 52, 2);
    font-family : 'Roboto Condensed';
    font-size   : 18px;
    cursor      : pointer;
    font-weight : bold  ;
  }
</style>
